<template>
    <div>
        <div class="ticker oswald-bold py-3">
          <template v-if="tickerData">
            <a v-if="tickerData.useLink" :href="tickerData.hyperlink" class="ticker-link">
              {{ tickerData.text }}
            </a>
            <span v-else>
              {{ tickerData.text }}
            </span>
          </template>
        </div>
        <Nav />
        <div v-if="homePageData">
            <div class="" :style="{ backgroundColor: homePageData ? homePageData.navbar_color : 'white' }">
                <div class="d-flex justify-content-center">
                    <img :src="homePageData ? `${$API_ASSETS}${homePageData.banner_image.id}.png` : 'white'"
                        class="img-fluid" alt="globe" />
                </div>
                <div class="d-flex align-items-center justify-content-center pt-3">
                    <div class="d-flex align-items-center text-start text-white px-5">
                        <i class="fa-solid fa-star d-none d-sm-block"></i>
                        <span class="text-uppercase h2 home-text mx-2 text-center">
                          Improv Shows Every Friday & Saturday
                        </span>
                        <i class="fa-solid fa-star d-none d-sm-block"></i>
                    </div>
                </div>
                <div class="d-flex align-items-center justify-content-center pt-5 pb-5">
                    <a :href="`${$TICKETS_URL}`">
                        <div class="btn ms-2 text-uppercase mb-5"
                            style="background-color:white; color:#E35B4B; border-radius: 1; min-width: 180px;"
                            type="button">Buy Tickets</div>
                    </a>
                </div>
            </div>
        </div>
        <UpcomingShows />
        <PageSections :sectionId="1" />
        <!-- <div class="container-fluid" style="background-color: black;">
            <div class="row chalk-row">
                <div class="col-md-6 offset-md-3 d-flex flex-column align-items-center justify-content-center">
                    <div class="text-center chalk-outline">
                        <div class="fs-1 text-uppercase text-white"> Take a Class</div>
                        <div class="fs-1 text-uppercase text-white"> With atlas improv</div>
                    </div>
                    <div class="text-white text-center">Atlas Improv's philosophy emphasizes character-based
                        storytelling, and, through our classes, we pass it on to our students. Besides being fun,
                        comprehensive, diverse and dynamic, our classes also build confidence, teamwork, leadership and
                        decision-making skills.</div>
                    <div class="text-white py-3 p text-center"> Every Fall, Spring, and Summer Semester, we typically
                        offer improv Core Class, Advanced Short-form and Long-form classes.</div>
                    <div class="pt-5">
                        <div class="btn ms-2 text-uppercase text-white chalk-btn "
                            style="background-color: #1A95AC; border-radius: 0;" type="button">Learn More</div>
                        <div class="btn ms-2 text-uppercase text-white chalk-btn  "
                            style="background-color: #1A95AC; border-radius: 0;" type="button">Register</div>
                    </div>

                </div>

            </div>

        </div>
        <div class="container-fluid" style="background-color:rgb(246,206,55);">
            <div class="row flex-row-reverse">
                <div class="col-md-6">
                    <div class="our-story">
                        <div class='h1 text-uppercase'> Our Story</div>
                        <div class="py-3">Atlas Improv was founded in early 2004 by Mary Parmentier and Bryan Judkins.
                            Their dream was to explore and innovate beyond what was familiar. As managers Parmentier and
                            Judkins sought a creative environment that challenged and fulfilled us artistically. They
                            knew we were capable of more and wanted to push us to new heights. They realized short-form
                            wasn’t enough. In 2004, they Started Atlas Improv. The active mebers of ComedySportz -
                            Madison followed Parmentier to do something new and amazing.</div>
                        <div class="py-3">Today Atlas Improv fosters an expert in each of its players. In story arc,
                            character building, or pure wite, every performer is a master.</div>
                        <div class="btn text-uppercase text-white chalk-btn my-5 orange-back " type="button">Learn More
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <img :src="`${$API_ASSETS}4b23b7c6-fb4b-44cd-bb1f-f52b097724eb.png`"
                        class="img-fluid w-100 d-md-inline" alt="globe" />
                </div>
            </div>

        </div> -->
        <Footer />

    </div>



</template>

<script>
import Footer from '../components/Footer.vue'
import { useHead } from '@vueuse/head';
import { useRoute } from 'vue-router';
import axios from 'axios'; // Import axios
import { mapState } from 'vuex';
import UpcomingShows from '../components/UpcomingShows.vue';
// import HomePageSections from '../components/HomePageSections.vue';
import Nav from "../components/Nav.vue"
import PageSections from '@/components/PageSections.vue';

export default {
    name: 'Home',
    setup() {
        const route = useRoute();
        useHead({
            title: route.meta.title || 'Atlas Improv',
            meta: [
                { name: 'description', content: route.meta.description || '' }
            ]
        });
        return {};
    },
    components: {
        Footer, UpcomingShows, Nav, PageSections
    },
    data() {
        return {
            homePageData: null,
            tickerData: null,
        };
    },
    computed: {
        ...mapState({
            count: state => state.count
        })
    },
    methods: {
        increment() {
            this.$store.dispatch('increment');
        },
        async fetchHomePageData() {
            const url = this.$API_GRAPHQL;
            try {
                const response = await axios.post(url, {
                    query: `
                      query {
                        home_page {
                          name
                          banner_image {
                            id
                          }
                          navbar_color
                          logo {
                            id
                          }
                        }
                          ticker{
                            text
                            useLink
                            hyperlink
                        }
                      }
                    `
                }, {
                    headers: {
                        'Authorization': `Bearer Pm4Nd5_e46HaK2xtkPcla2PMBzbk9AQf`, // Use the provided key
                        'Content-Type': 'application/json'
                    }
                });

                this.homePageData = response.data.data.home_page;
                this.tickerData = response.data.data.ticker;
                console.log('Home Page Data:', this.homePageData);
            } catch (error) {
                console.error('Error fetching home page data:', error);
            }
        }
    },
    created() {
        console.log('Home component created, count:', this.count);
        this.fetchHomePageData(); // Fetch the data when the component is created
    },
    updated() {
        console.log('Home component updated, count:', this.count);
    }
};
</script>

<style scoped>
.ticker {
  width: 100%;
  background-color: #000;
  color: #fff;
  text-align: center;
  padding: 0.5rem 0;
}
.ticker-link {
  color: #fff;
  text-decoration: none;
}
</style>
